import { render } from "./alertdiypage.vue?vue&type=template&id=0ee9063c&scoped=true"
import script from "./alertdiypage.vue?vue&type=script&lang=js"
export * from "./alertdiypage.vue?vue&type=script&lang=js"

import "./alertdiypage.vue?vue&type=style&index=0&id=0ee9063c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee9063c"]])

export default __exports__